
import React from 'react'
import AOS from 'aos';
import { Intro, Projects, Model, Design, Traditional, About } from '../pages';
import graphic from '../assets/bottom_graphic.svg';
import NavBar from './navbar';
import Footer from './footer';
import 'aos/dist/aos.css';
import './Nav.scss';
import '../pages/index.scss';

export default function App() {
  const sections = [
    {
      name: 'home',
      url: 'home',
      component: <Intro />
    },
    {
      name: 'projects',
      url: 'projects',
      component: <Projects />
    },
    {
      name: 'traditional art',
      url: 'traditional',
      component: <Traditional />
    },
    {
      name: 'design',
      url: 'art_design',
      component: <Design />
    },
    {
      name: '3d modeling',
      url: '3d_model',
      component: <Model />
    },
    {
      name: 'about',
      url: 'about',
      component: <About />
    },
  ]

  AOS.init({
    duration: 1200,
  })

  window.addEventListener(
    'scroll',
    () => {
      document.body.style.setProperty(
        '--scroll',
        window.pageYOffset / (document.body.offsetHeight - window.innerHeight)
      );
    },
    false
  );

  return (
    <div className='App'>
      <NavBar sections={sections} />
      {
        sections?.map((item) =>
          <div>
            <section id={item.url} className='parent'>
              {item.url !== 'home' ? <div className='space_divider'></div> : ''}
              {item.url !== 'home'
                ? <div data-aos='fade-up' className='child'>{item.component}</div>
                : <div className='child'>{item.component}</div>
              }
            </section>
          </div>
        )
      }
      <Footer />
      <img src={graphic} className='graphic' alt='footer graphic' />
    </div>
  );
}
